import { render, staticRenderFns } from "./GridPatentes.vue?vue&type=template&id=15b7cf58&"
import script from "./GridPatentes.vue?vue&type=script&lang=ts&"
export * from "./GridPatentes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports